import React from "react";
import { useState } from "react";
import { Link } from "react-router-dom";
import { Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "../../Styles/BookSlider.css";

const BookSlider = ({
  slides,
  setSelectedBook,
  isLink,
  linkPattern,
  style,
  breakPoint,
}) => {
  const [bookIndex, setBookIndex] = useState(0);
  const clickSlide = (i) => {
    setBookIndex(i);
    setSelectedBook(slides[i]);
  };

  return (
    <Swiper
      slidesPerView={2}
      navigation
      modules={[Pagination]}
      spaceBetween={1}
      className={"BookSlider_swiper-wrapper"}
      onSlideChange={(ex) => clickSlide(ex.activeIndex)}
      breakpoints={breakPoint}
    >
      {slides.map((slide, i) => (
        <SwiperSlide style={{ textAlign: "center" }} key={i}>
          {isLink ? (
            <Link
              to={
                linkPattern == "/hisstori/blog"
                  ? `${linkPattern}/${slide.id}`
                  : slide.id < 10
                  ? `${linkPattern}/SE0${slide.id}/${slide.preTitle}`
                  : `${linkPattern}/SE${slide.id}/${slide.preTitle}`
              }
              id={`Group${slide.id}`}
              style={{
                textDecoration: "none",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              <img
                id={slide.id}
                src={slide.pic}
                alt={slide.title}
                style={style}
                className={`BookSlider_book_img ${
                  i == bookIndex ? "BookSlider_book_active" : ""
                }`}
                onClick={() => clickSlide(i)}
              />
              <p className="BookSlider_book_name">{slide.title}</p>
            </Link>
          ) : (
            <>
              <img
                id={slide.id}
                src={slide.pic}
                alt={slide.title}
                style={style}
                className={`BookSlider_book_img ${
                  i == bookIndex ? "BookSlider_book_active" : ""
                }`}
                onClick={() => clickSlide(i)}
              />
              <p className="BookSlider_book_name">{slide.title}</p>
            </>
          )}
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

BookSlider.defaultProps = {
  isLink: false,
  setSelectedBook: (book) => {},
  linkPattern: "/book",
  style: { height: 270 },
};

export default BookSlider;
